import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TituloReceberSituacaoMultiselectComponent } from './multiselect';
import { TituloReceberSituacaoPipe } from './pipes';
import { TituloReceberSituacaoSelectComponent } from './select';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TituloReceberSituacaoMultiselectComponent,
        TituloReceberSituacaoSelectComponent,

        TituloReceberSituacaoPipe
    ],
    exports: [
        TituloReceberSituacaoMultiselectComponent,
        TituloReceberSituacaoSelectComponent,

        TituloReceberSituacaoPipe
    ],
    providers: [
        TituloReceberSituacaoPipe
    ]
})
export class TituloReceberSituacaoModule { }
